import { site } from '@yola/ws-sdk';
import store from 'src/js/store';

function getDescendantFolderIds(folderId, folders) {
  const directChildren = folders.filter((folder) => folder.parentFolderId === folderId);
  return directChildren.reduce((acc, child) => {
    acc.push(child.id, ...getDescendantFolderIds(child.id, folders));
    return acc;
  }, []);
}

async function performFolderDelete({ folderId, pages, activePageId }) {
  const state = store.getState();
  const folders = site.selectors.getFolders(state);
  const descendantFolderIds = getDescendantFolderIds(folderId, folders);
  const allFolderIdsToDelete = new Set([folderId, ...descendantFolderIds]);

  const activePage = pages.find((page) => page.id === activePageId);
  const isDeletingFolderWithActivePage =
    activePage && allFolderIdsToDelete.has(activePage.parentFolderId);

  if (isDeletingFolderWithActivePage) {
    const remainingPages = pages.filter(
      (page) => page.locale === activePage.locale && !allFolderIdsToDelete.has(page.parentFolderId)
    );
    const homePage = remainingPages.find((page) => site.verifiers.isHomePage(page.path));
    const fallbackPage = homePage || remainingPages[0];

    if (fallbackPage) {
      await site.operations.setActivePage(fallbackPage.id);
    }
  }

  [...descendantFolderIds].reverse().forEach((id) => {
    store.dispatch(site.actions.deleteFolder(id));
  });

  store.dispatch(site.actions.deleteFolder(folderId));
}

export default performFolderDelete;
